if (!customElements.get('complementary-products')) {
	customElements.define('complementary-products', class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.itemAdded = false
      if (this.submitButton && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      if(this.querySelector('.complementary__actions')) {
        this.price = this.querySelector('.complementary__total__price');
        this.querySelectorAll('.select__select,input.complementary-variant-id[data-available="true"],.quantity__input').forEach(element => {
          element.addEventListener('change', this.onChangeHandler.bind(this));
        });
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      
      let formData = {};
      if (this.cart) {
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
        formData.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }
      
      /* Collection items */
      let items = [];
      this.querySelectorAll('.complementary__item').forEach((item) => {
        const quantityInput = item.querySelector('.quantity__input');
        if(parseInt(quantityInput.value) > 0) {
          items.push({
            id: item.querySelector('.complementary-variant-id').value,
            quantity: quantityInput.value
          });
        }
      });
      formData.items = items;
      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          document.dispatchEvent(new CustomEvent('afterCartChanged'));
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    pushErrorMessage(content) {
      pushMessage(content, 'error');
    }

    onChangeHandler(evt) {
      const currentItem = evt.target.closest('.complementary__item');
      const quantityInput = currentItem.querySelector('.quantity__input');
      const newQuantity = parseInt(quantityInput.value || 0);
      const previousQuantity = parseInt(quantityInput.dataset.previousQuantity || 0);
      const variantSelect = currentItem.querySelector('.complementary-variant-id');
      const variantId = variantSelect.value;

      const minusButton = currentItem.querySelector('button[name="minus"]');
      const plusButton = currentItem.querySelector('button[name="plus"]');
      const selectedItem = currentItem.querySelector(".complementary__item__title a").textContent;

      const quantityForm = evt.target.closest('.complementary__item__quantity');
      const throwError = quantityForm.classList.contains("disabled") && minusButton.classList.contains("hidden")

      if(throwError) {
        this.pushErrorMessage("Du hast bereits ein Zusatzprodukt gewählt")
      }

      const cartBubbleCount = document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]')
      let ajaxEndPoint
      let adjustedQuantity
      if(this.itemAdded) {
        ajaxEndPoint = 'change.js' 
        adjustedQuantity = 0;
        if(cartBubbleCount && !throwError) {
          cartBubbleCount.textContent = parseInt(cartBubbleCount.textContent) - 1
        }
      } else {
        ajaxEndPoint = 'add.js'
        adjustedQuantity = 1  
        if(cartBubbleCount && !throwError) {
          cartBubbleCount.textContent = parseInt(cartBubbleCount.textContent) + 1
        }
      }

      if(!currentItem.classList.contains("complementary__item-in-cart")) {
        // console.log("does not contain")
        document.querySelector(".complementary__actions button").click();
      } else {
        // console.log("CONTAINS")
        if (!throwError) {
          fetch(`/cart/${ajaxEndPoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: adjustedQuantity
            })
          })
          .then(res => res.json())
          .then((cart) => {
            if(!this.itemAdded) {
              console.log("ITEM ADDED", adjustedQuantity)
              this.itemAdded = true
              minusButton.classList.remove("hidden")
              plusButton.classList.add("hidden") 
              pushSuccessMessage(`${selectedItem} wurde erfolgreich in den Warenkorb gelegt.`);  
            } else {
              this.itemAdded = false
              minusButton.classList.add("hidden")
              plusButton.classList.remove("hidden")
              pushSuccessMessage(`${selectedItem} wurde entfernt.`); 
            }
              // Recalculate total complementary price
              
              this.recalculateComplementaryTotals();
          })
          .catch((e) => {
            console.error('Error updating cart quantity:', e);
          });
        }
      }

     
      
    }

    recalculateComplementaryTotals() {
      let totalPrice = 0, totalCompareAtPrice = 0, totalQuantity = 0;
      this.querySelectorAll('.complementary__item__info--variant').forEach(element => {
        const variantTag = element.querySelector('.complementary-variant-id');
        let attributeTag = variantTag;
        if (variantTag.classList.contains('select__select')) {
          attributeTag = variantTag.querySelector('option:checked');
        }
        if (attributeTag.dataset.available === 'true') {
          const input = element.querySelector('.quantity__input');
          const quantity = parseInt(input.value);
          
          totalQuantity += quantity;
          totalPrice += parseInt(attributeTag.dataset.price) * quantity;
          totalCompareAtPrice += parseInt(attributeTag.dataset.compareAtPrice) * quantity;
        }
      });
    
      const quantityInputs = this.querySelectorAll('.quantity__input');
    
      const quantityDiv = document.querySelector('.cart-notification__quantity.flex.caption');
      let mainItemQuantity;
    
      if (quantityDiv) {
        const quantityTextcontent = quantityDiv.querySelectorAll('span')[1];
        mainItemQuantity = parseInt(quantityTextcontent.textContent, 10);
      } else {
        mainItemQuantity = 1;
      }
      if (this.itemAdded) {
        if(!quantityDiv) {
          document.body.classList.add("includes-extra")
        }
        quantityInputs.forEach(input => input.parentElement.classList.add('disabled'));
      } else {
        if(!quantityDiv) {
          document.body.classList.remove("includes-extra")
        }
        quantityInputs.forEach(input => input.parentElement.classList.remove('disabled'));
      }
    
      if (this.price) this.updatePrice(this.price, totalPrice, totalCompareAtPrice, true);
    
      if (this.submitButton) {
        if (totalQuantity > 0) {
          this.submitButton.removeAttribute('disabled');
        } else {
          this.submitButton.setAttribute('disabled', 'disabled');
        }
      }
    }
    

    updatePrice(priceElement, price, compareAtPrice, noConvert) {
      priceElement.update(price, compareAtPrice, noConvert);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}